import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Collapse,
  Checkbox,
  Select,
} from "antd";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { PostGroupISMSUserApi } from "api/getGroup";
import {
  openNotificationWithIcon,
  validateMessages,
} from "../../../../Function";
import "./ModalUserGroup.css";
const { Panel } = Collapse;

const EditUserGroup = ({
  open,
  onCancel,
  detailUser,
  arrTypeQuestion,
  fetchDataUser,
  currentTeam,
  lsTeam,
  isTypeAdd,
}) => {
  const [form] = Form.useForm();
  const [inputTypeQs, setInputTypeQs] = useState("");

  useEffect(() => {
    form.resetFields();

    if (isTypeAdd == false) {
      // Chỉnh sửa nhóm thi theo từng user
      form.setFieldsValue({
        loai_cau_hoi: detailUser.data_group_isms.map((item) => item.id),
      });
    }

  }, [open]);

  const onFinish = (values) => {
    const resultGroup = values.loai_cau_hoi.sort((a, b) => a - b).join(",");

    if (isTypeAdd) {
      // Gán nhóm thi theo team
      PostGroupISMSUserApi({
        id_team: values.id_team,
        str_id_group: resultGroup,
      })
        .then((res) => {
          if (res.data.error) {
            openNotificationWithIcon("error", res.data.error);
          } else {
            openNotificationWithIcon("success", res.data.message);
            onCancel();
            form.resetFields();
            fetchDataUser({ idTeam: JSON.stringify(currentTeam) });
          }
        })
        .catch((err) => {
          if (err.data.error) {
            openNotificationWithIcon("error", err.data.error);
          }
        });
    } else {
      // Gán nhóm thi theo user
      PostGroupISMSUserApi({
        ls_id_user: [detailUser.id],
        str_id_group: resultGroup,
      })
        .then((res) => {

          if (res.data.error) {
            openNotificationWithIcon("error", res.data.error);
          } else {
            openNotificationWithIcon("success", res.data.message);
            onCancel();
            form.resetFields();
            fetchDataUser({ idTeam: JSON.stringify(currentTeam) });
          }
        })
        .catch((err) => {
          if (err.data.error) {
            openNotificationWithIcon("error", err.data.error);
          }
        });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={isTypeAdd ? `Gán nhóm thi cho Team` : `Gán nhóm thi cho nhân viên [${detailUser.username}]`}
      style={{ minWidth: "300px" }}
      width={500}
      footer={false}
      bodyStyle={{ paddingTop: 6 }}
      maskClosable={false}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        {isTypeAdd && (
          <Form.Item label="Team" name="id_team" rules={[{ required: true }]}>
            <Select>
              {lsTeam &&
                lsTeam.map((item, index) => (
                  <Select.Option key={item.idTeam} value={item.idTeam}>
                    {item.team}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          label="Nhóm thi"
          name="loai_cau_hoi"
          // rules={[
          //   { required: true, message: "Vui lòng chọn ít nhất một nhóm!" },
          // ]}
        >
          <Checkbox.Group className="checkbox-group">
            <div className="checkbox-grid">
              {arrTypeQuestion.map((group) => (
                <label key={group.id} className="checkbox-item">
                  <Checkbox value={group.id} />
                  <span className="checkbox-label">
                    {group.note} ({group.loai_cau_hoi})
                  </span>
                </label>
              ))}
            </div>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
          <Button type="success" htmlType="submit" className={"m-2"}>
            Tạo
          </Button>
          <Button onClick={onCancel}>Thoát</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUserGroup;
